'use client';

import * as React from 'react';
import { Player } from '@alien-platform/bo-core';
import { Button, Card, CardContent, CircularProgress, OutlinedInput, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { BetDetailsTable } from './player-details-table';
import PlayerGroupSection from './player-group-section/player-group-section';

export function PlayerDetailsTab({ playerData }: { playerData: Player | undefined }): React.JSX.Element {
  return (
    <Stack direction="column">
      {!playerData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <BetDetailsTable playerData={playerData} />

          <PlayerGroupSection />

          <Card>
            <CardContent>
              <Stack direction="column" gap={1.5}>
                <Typography variant="h6">Admin Notes</Typography>
                <OutlinedInput multiline placeholder="Write a note" />
                <Box>
                  <Button variant="contained" color="success" sx={{ flexShrink: 0 }}>
                    Save Note
                  </Button>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      )}
    </Stack>
  );
}
